import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CLASS_STYLES, ScoreRing } from "@/lib/match";
import { Badge } from "@/components/ui/badge";
import { ShieldAlert } from "lucide-react";

export default function ReviewQueue() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/review-queue").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-8 max-w-6xl">
      <div className="mb-6 fade-up">
        <div className="text-xs uppercase tracking-widest text-[hsl(var(--teal))] font-semibold">Human Oversight</div>
        <h1 className="font-head text-3xl font-semibold tracking-tight mt-1">Review Queue</h1>
        <p className="text-muted-foreground mt-2">Matches flagged for recruiter judgement — missing mandatory qualifications, insufficient information or explicit human-review recommendations.</p>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-border rounded-xl"><p className="text-muted-foreground">Nothing needs review right now.</p></div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.match_id} data-testid={`review-item-${m.match_id}`} onClick={() => navigate(`/candidates/${m.candidate_id}`)}
              className="card-hover flex items-center gap-4 bg-white border border-border rounded-xl p-4 cursor-pointer">
              <ScoreRing score={m.score || 0} size={48} />
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{m.position_title}</div>
                <div className="text-xs text-muted-foreground truncate">{m.client}</div>
              </div>
              <div className="flex items-center gap-2">
                {m.missing_mandatory && <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200"><ShieldAlert size={12} className="mr-1" />Missing mandatory</Badge>}
                <Badge variant="outline" className={`capitalize border ${CLASS_STYLES[m.classification] || ""}`}>{m.classification}</Badge>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
